import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import { AdesioneB2CForm, ListingHead, Page } from 'components/organisms'
import styles from './AdesioneB2CTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const AdesioneB2CTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main className={styles.layout}>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <AdesioneB2CForm />
        </div>
      </main>
    </Page>
  )
}

export default AdesioneB2CTemplate
